var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgErrorHollow = function SvgErrorHollow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none",
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M12.7666 23C6.6913 23 1.7666 18.0753 1.7666 12C1.7666 5.9247 6.6913 1 12.7666 1C18.8419 1 23.7666 5.9247 23.7666 12C23.7666 18.0753 18.8419 23 12.7666 23ZM12.7666 20.8C15.1005 20.8 17.3388 19.8729 18.9891 18.2225C20.6395 16.5722 21.5666 14.3339 21.5666 12C21.5666 9.66609 20.6395 7.42778 18.9891 5.77746C17.3388 4.12714 15.1005 3.2 12.7666 3.2C10.4327 3.2 8.19438 4.12714 6.54406 5.77746C4.89374 7.42778 3.9666 9.66609 3.9666 12C3.9666 14.3339 4.89374 16.5722 6.54406 18.2225C8.19438 19.8729 10.4327 20.8 12.7666 20.8ZM11.6666 15.3H13.8666V17.5H11.6666V15.3ZM11.6666 6.5H13.8666V13.1H11.6666V6.5Z"
  })));
};
export default SvgErrorHollow;